import {
	Component,
	ContentChild,
	ElementRef,
	HostListener,
	Inject,
	Input,
	OnDestroy,
	OnInit,
	TemplateRef,
	ViewChild
} from '@angular/core';
import { SliderService } from '../services/slider/slider.service';
import { Observable, Subscription } from 'rxjs';
import { SliderDirection } from './slider-direction';
import { HEADING_SIZES, HEADING_TYPES } from '../heading/heading.enum';
import { SliderStyle } from './slider-style.interface';
import { DOCUMENT } from '@angular/common';
import { WINDOW } from '@edassist/common';

@Component({
	selector: 'ea-slider',
	templateUrl: './slider.component.html',
	styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit, OnDestroy {
	HEADING_TYPES = HEADING_TYPES;
	HEADING_SIZES = HEADING_SIZES;
	showSlider: Observable<boolean>;
	sliderStyle: SliderStyle;

	@ContentChild('slidingPanel') slidingPanelTemplate: TemplateRef<any>;
	@ViewChild('sliderContent') sliderContentRef: ElementRef;
	@Input() duration = 0.25;
	@Input() direction: SliderDirection = SliderDirection.Left;
	@Input() sliderId: string;
	@Input() isActive = false;
	@Input() setSliderBgColor = false;
	// width ratio represents the percent of the space the slider of the viewport, default is (100%)
	@Input() widthPercent = 100;

	protected readonly subscriptions = new Subscription();

	constructor(
		@Inject(DOCUMENT) private readonly document: Document,
		@Inject(WINDOW) private readonly window: Window,
		private readonly sliderService: SliderService
	) {}

	@HostListener('window:resize', ['$event'])
	onResize(): void {
		this.setSliderStyle(true);
	}

	ngOnInit(): void {
		// So first time opening isn't 'janky', need to set CSS
		this.setSliderStyle(this.isActive);
		this.subscriptions.add(
			this.sliderService.closeSliderEvent.subscribe((sliderId) => {
				if (sliderId === this.sliderId) {
					this.close();
					this.document.body.style.overflowY = 'scroll';
					this.setSliderStyle(this.isActive);
				}
			})
		);
		this.subscriptions.add(
			this.sliderService.openSliderEvent.subscribe((sliderId) => {
				if (sliderId === this.sliderId) {
					this.isActive = true;
					this.document.body.style.overflowY = 'hidden';
					this.setSliderStyle(this.isActive);
				}
			})
		);
	}

	close(): void {
		this.setSliderStyle(false);
		this.isActive = false;
		this.document.body.style.overflowY = 'scroll';
	}

	setSliderStyle(showSlider: boolean): void {
		const percentAsWidth = this.widthPercent * 0.01;
		const sliderWidth = `${this.window.innerWidth * percentAsWidth}`;
		this.sliderStyle = {
			transition: `${this.direction} ${this.duration}s, visibility ${this.duration}s`,
			width: `${sliderWidth}px`,
			[this.direction]: `${showSlider ? 0 : parseFloat(sliderWidth) * -1}px`
		};
	}

	ngOnDestroy(): void {
		this.document.body.style.overflow = 'auto';
		this.subscriptions.unsubscribe();
	}
}
